import Fragment from "./fragment";

export default class Safety extends Fragment {}
